$(document).ready(function () {
  $(".Collapsible__Inner ").hide();
  $(document).on("click", ".Collapsible__Button", function () {
    // $('.Collapsible__Button').removeClass('active');
    $(this).toggleClass("active");
    $(this).next(".Collapsible__Inner ").slideToggle();
    $(".Collapsible__Inner ").not($(this).next()).slideUp();
    // sliderInit();
  });

  // $(".prod_splide__list").slick({
  //   dots: true,
  //   infinite: false,
  //   speed: 300,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  // });
  // sliderInit();
  $(document).on("click", ".header-sidebar__footer .localization-toggle", function (e) {
    $(".header-sidebar__footer .localization-selectors x-popover").show();
  });
  $(document).on("click", "x-header.header .localization-toggle", function (e) {
    console.log("dghdgjh");
    $(this).parents(".localization-selectors").find(".popover").toggle();
    if ($(window).width() < 767) {
      $(".localization-wrapper x-popover").show();
      $('html').addClass('lock')
    }
  });
  $(document).on("click touch", function (event) {
    if (!$(event.target).parents().addBack().is('.localization-toggle')) {
      console.log('kdjhgj');
     $('html').removeClass('lock');
     $(".localization-wrapper x-popover").hide()
     $(".localization-selectors x-popover").hide();
    }
  });
  $(document).on("click", ".share_button", function (e) {
    $(".round_button").toggle();
    $(".icon_close").toggle();
    $(this).toggleClass('active');
    $(".share-buttons__list").toggle();
  });
});

function sliderInit() {
  if ($(".splide__list").hasClass("slick-initialized")) {
    $(".splide__list").slick("refresh");
  } else {
    $(".splide__list").slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
}
const readMoreButtons = document.querySelectorAll('button.Read_more_AA');

Array.from(readMoreButtons).forEach(function (btn) {
    btn.addEventListener('click', function () {
        const readMoreSpan = this.parentElement.nextElementSibling;
        if (readMoreSpan.style.display === "block") {
            readMoreSpan.style.display = "none";
            this.innerHTML = "Read more";
            this.style.marginBottom = "20px";
        }
        else {
            readMoreSpan.style.display = "block";
            this.innerHTML = "Read less";
            this.style.marginBottom = "0px";
        }
    });
});